<mat-toolbar
  #mainToolbar
  id="main-toolbar"
  color="primary"
>

  <span id="title" routerLink="/">
    <button id="totamusica-icon" mat-icon-button>
      <img src="../../../assets/icons/icon-384x384.png">
    </button>
    <span id="totamusica">
      {{title}}
    </span>
  </span>

  

  
  <span class="spacer"></span>



  <!-- MAIN MENU -->
  <span id="main-menu" *ngIf="showMenu">

    <!-- MANAGE USERS BUTTON -->
    <!--span
      *ngIf="auth.userIsAdmin"
      matRipple
      [matRippleCentered]="true"
      [matRippleColor]="'#ccc6'"
      id="edit-pcset-infos-btn" 
      class="menu-btn" 
      routerLink="/manage-users"
      routerLinkActive="active"
    >
      <mat-icon
        matTooltip="MANAGE USERS"
        [matTooltipDisabled]="!showMainMenuTooltip"
        matTooltipShowDelay="1000"
      >
        group
      </mat-icon>
      <span class="menu-text-item">Manage<br>Users</span>
    </span-->

    <!-- MANAGE AUDIOS BUTTON -->
    <span
      matRipple
      [matRippleCentered]="true"
      [matRippleColor]="'#ccc6'"
      id="edit-pcset-infos-btn" 
      class="menu-btn" 
      routerLink="/manage-audios"
      routerLinkActive="active"
    >
      <span class="menu-text-item">Manage<br>Audios</span>
    </span>
    
    <!-- MANAGE VIDEOS BUTTON -->
    <span
      matRipple
      [matRippleCentered]="true"
      [matRippleColor]="'#ccc6'"
      id="edit-pcset-infos-btn" 
      class="menu-btn" 
      routerLink="/manage-videos"
      routerLinkActive="active"
    >
      <span class="menu-text-item">Manage<br>Videos</span>
    </span>

    <!-- MANAGE PHOTOS BUTTON -->
    <span
      matRipple
      [matRippleCentered]="true"
      [matRippleColor]="'#ccc6'"
      id="edit-pcset-infos-btn" 
      class="menu-btn" 
      routerLink="/manage-photos"
      routerLinkActive="active"
    >
      <span class="menu-text-item">Manage<br>Photos</span>
    </span>

    <!-- MANAGE PHOTOS BUTTON -->
    <span
      matRipple
      [matRippleCentered]="true"
      [matRippleColor]="'#ccc6'"
      id="edit-pcset-infos-btn" 
      class="menu-btn" 
      routerLink="/manage-albums"
      routerLinkActive="active"
    >
      <span class="menu-text-item">Manage<br>Albums</span>
    </span>

    <!-- BACKUP BUTTON -- >
    <span
      matRipple
      [matRippleCentered]="true"
      [matRippleColor]="'#ccc6'"
      id="edit-pcset-infos-btn" 
      class="menu-btn" 
      routerLink="/backup"
      routerLinkActive="active"
    >
      <mat-icon
        matTooltip="DATA BACKUP"
        [matTooltipDisabled]="!showMainMenuTooltip"
        matTooltipShowDelay="1000"
      >
        browser_updated
      </mat-icon>
      <span class="menu-text-item">Data<br>Backup</span>
    </span-->

  </span>





  <span class="spacer"></span>
   




   



  <!-- USER ACCOUNT - TOP-RIGHT -->
  <span id="right-container">
    <mat-spinner 
      id="spinner" 
      *ngIf="isLoading; else notLoading"
      color="accent" 
      diameter="40"
    />
    <ng-template #notLoading>
      <span id="network-clip" [class.offline]="!connected"></span>
      <div id="user-container">
        <span 
          id="user" 
          *ngIf="auth.isAuthenticated" 
          matTooltip="account: {{auth.userName}} {{auth.userEmail}}" 
          matTooltipShowDelay="1000"
        >
          <button mat-icon-button aria-label="menu" 
            [matMenuTriggerFor]="userMenu" 
            *ngIf="auth.isAuthenticated"
            [ngClass]="{'zero-padding': auth.userPhotoUrl}"
          >
            <mat-icon id="icon-account" *ngIf="!auth.userPhotoUrl">account_circle</mat-icon>
            <img *ngIf="auth.userPhotoUrl" [src]="auth.userPhotoUrl" class="user-photo">
          </button>
          <span id="welc-name">{{auth.userName}}</span>
        </span>
          
        <!-- USER MENU -->
        <mat-menu #userMenu>
          
          <!-- LOGOUT BUTTON -->
          <button mat-menu-item aria-label="Logout" (click)="auth.logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>

          <!-- TEST BUTTON -->
          <button *ngIf="auth.userStatus === 'SUPER'" mat-menu-item routerLink="/test">
            <span>TEST</span>
          </button>
        </mat-menu>


        
        <!-- IF NOT AUTHENTICATED => ROUTE TO LOGIN PAGE -->
        <button 
          *ngIf="!auth.isAuthenticated"
          routerLink="/login" 
          routerLinkActive="active" 
          mat-icon-button 
          aria-label="Login" 
          matTooltip="LOGIN or CREATE ACCOUNT" 
          matTooltipShowDelay="1000"
        >
          <mat-icon id="icon-person">person</mat-icon>
        </button>

      </div>
    </ng-template>
  </span>
  
</mat-toolbar>
